import Handlebars from "hbs";

import HomeRepair from "./homeRepair";
import SaLogin from "./saLogin";

import { googleMaps } from "./vendor";

// SR creation lockers
import StoreLocatorv1 from "./storeLocator-v1";

// ==================
// Templates
// ==================
import RepairSolution from "../../templates/components/repair-solution.html";
import UBPriceTemplate from "../../templates/components/ub-price.html";
import RepairSteps from "../../templates/components/repair-steps.html";
import daysConfirmation from "../../templates/components/days-confirmation.html";
//import ConfirmPopup from '../../templates/components/confirm-popup/popup.html';

import RSCopyIE from "../../copy/ie/repair-services.json";

import RSCopyUK from "../../copy/uk/repair-services.json";

import UBPrice from "../../copy/uk/ub-price.json";
import RepairStepsContentUK from "../../copy/uk/repair-steps.json";
import RepairStepsContentIE from "../../copy/ie/repair-steps.json";

import ConfirmPopup from "./confirmPopup";
import { replace } from "lodash";

export default class TsInterpreter {
  constructor(tsOutcome = null) {
    if (tsOutcome == null) {
      this.tsEvents();
    } else {
      this.init();
      this.handleTsOutcome(tsOutcome);
    }
  }

  init() {
    this.TAG = "repairbooking";
    this.templates = {};
    this.ubModels = [];

    this.currentiFrameHeight = 0;

    this.templates.repairSolution = RepairSolution;
    this.templates.ubPrice = UBPriceTemplate;
    this.templates.repairSteps = RepairSteps;
    this.templates.daysConfirmation = daysConfirmation;

    this.gaId =
      location.host == "p6-qa.samsung.com"
        ? "UA-101298876-1"
        : "UA-100137701-12";

    //this.templates.confirmPopup = ConfirmPopup;

    //this.initConfirmPopup();

    /** Need to check commenting this two lines how to affect the flow  for samsung account integration**/
    //window.state.selectedservice = "";
    //window.state.tsoutcome = {};

    this.hideConctactDialogue();
    this.events();
  }

  events() {
    var $this = this;
    var openChat = false;

    $("#repair-solutions .services a.repair-soluton-btn")
      .off("click")
      .on("click", function (e) {
        e.preventDefault();
        if (window.state.selectedservice != "KISS") {
          window.state.selectedservice = $(this).data("service-type");
        }

        if (window.state.selectedservice == "PS" && site == "uk") {
          $this.handleClickedServiceType();
          /*

                //$this.ubModels = $this.getUBPriceProductAndSetProductImage();

                //console.log($this.ubModels);

                // UB pricing for mobile pickup repair
                var UBPRPrice = $this.ubPickupRepairPrice();

                //console.log(UBPRPrice);
                var troubleShootedProduct = window.state.tsoutcome.troubleshootedProduct.split('/')[1].toLowerCase();
                troubleShootedProduct = troubleShootedProduct.replace('galaxy', '');
                troubleShootedProduct = troubleShootedProduct.replace('5g', '');

                //var  isUBPriceProduct = false;
                var UBPRPriceForSelectedProduct = "";

                //console.log('Inside handling UB price');
                //console.log(UBPRPrice);

                var isUBPriceProduct = UBPRPrice.some(element => {


                    // troubleshooter outcome come with the product name plus instead of +
                    var model = element.model.toLowerCase();
                    model = model.replace(/ /g, '');
                    model = model.replace('+', 'plus');
                    model = model.replace('5g', '');

                    //console.log(troubleShootedProduct);
                    //console.log(model);
                    //console.log(troubleShootedProduct.includes(model));

                    if (troubleShootedProduct == model) {
                        UBPRPriceForSelectedProduct = element;
                        return true;
                    } else {
                        return false;
                    }

                });


                if (isUBPriceProduct && (window.state.tsoutcome.selectedIssue == "Smashed or damaged screen" || window.state.tsoutcome.selectedIssue == "Smashed or damaged device") ){

                   // console.log('Inside if');
                    $this.drawUBPriceSection(UBPRPriceForSelectedProduct);
                    $this.scrollTo('#repair-solutions', 500);

                } else {

                    $this.handleClickedServiceType();

                }

                */
        } else if (e.target.classList.contains("repair-solution-trade-btn")) {
          window.open(e.target.href, "_blank");
        } else {
          $this.handleClickedServiceType();
        }
      });

    $("#repair-solutions .services a.repair-solution-back-btn")
      .off("click")
      .on("click", function (e) {
        e.preventDefault();
        window.state.isBatteryReplacement = false;
        $("#repair-solutions").html("");
        $("#repair-solutions").hide();
        $("#sa-login").hide();
        $this.hideRepairSteps();

        if (window.state.category == "mobile") {
          $("#care-plus-repair").show();
          $this.scrollTo("#care-plus-repair", 500);
        } else {
          $this.scrollTo("#products-section", 500);
        }
      });

    $("#ub-pr-price .services a.repair-soluton-btn")
      .off("click")
      .on("click", function (e) {
        e.preventDefault();
        //console.log('Is UB Price',$(this).data('repair-price'));

        window.state.isUBPrice =
          $(this).data("repair-price") == "ubrrp" ? true : false;

        $this.handleClickedServiceType();
      });

    $("#doorsteprepaircta a:nth-child(2)")
      .off("click")
      .on("click", function (e) {
        e.preventDefault();
        $this.showConfirmPopup();
      });

    $("#dsr-surcharge-txt a")
      .off("click")
      .on("click", function (e) {
        e.preventDefault();
        $this.scrollTo("#screen-repair-banner", 300);
      });

    // Video thumbs clicked

    $(".dsr-video").on("click", function (e) {
      e.preventDefault();
      $(
        "#video-thumb .video-card__inner .video-card__item:nth-child(1) button"
      ).trigger("click");
    });

    $(".ps-video").on("click", function (e) {
      e.preventDefault();
      $(
        "#video-thumb .video-card__inner .video-card__item:nth-child(2) button"
      ).trigger("click");
    });

    $(".isr-video").on("click", function (e) {
      e.preventDefault();
      $(
        "#video-thumb .video-card__inner .video-card__item:nth-child(3) button"
      ).trigger("click");
    });

    $(".ih-video").on("click", function (e) {
      e.preventDefault();
      $(
        "#video-thumb .video-card__inner .video-card__item:nth-child(4) button"
      ).trigger("click");
    });

    $("#care-plus-false")
      .off("click")
      .on("click", function (e) {
        e.preventDefault();
        $("#bespoke-flip-banner").hide();
        $("#cheil-static-app").hide();
        window.supportComponents.steps.setActiveStep(3);
        //console.log(JSON.parse(tsOutcome));
        $this.checkAvailableRepairServiceList();
      });

    $("#care-plus-true")
      .off("click")
      .on("click", function (e) {
        e.preventDefault();
        $("#bespoke-flip-banner").hide();
        var isLocalEnv =
          window.location.host == "www.samsung.com" ||
          window.location.host == "p6-qa.samsung.com"
            ? false
            : true;

        if (!isLocalEnv) {
          window.resetCarePlusModule();
        }

        $("#cheil-static-app").show();
        $(".btn-hide a").show();
        $this.scrollTo("#cheil-static-app", 100);
      });

    $("#continue-as-gust")
      .off("click")
      .on("click", function (e) {
        e.preventDefault();
        $("#sa-login .banner-wrapper").hide();
        $("#sa-login #sa-login-back-btn").hide();

        if (window.state.selectedservice == "ISR") {
          $this.scrollToRepairBookingSection("#instore-repair-map");
          //$this.scrollTo('#repair-booking-form', 500);
          $this.showInstoreRepairMap();
        } else {
          $this.scrollToRepairBookingSection("#repair-request-form");
          //$this.scrollTo('#repair-booking-form', 500);
          $this.showBookingRepairForm();
        }
      });

    $("#continue-repair")
      .off("click")
      .on("click", function (e) {
        e.preventDefault();
        $this.hideRepairSteps();

        $this.showSamsungMembersCTA();

        /** if (window.state.selectedservice == "ISR") {

                $this.scrollToRepairBookingSection('#instore-repair-map');
                //$this.scrollTo('#repair-booking-form', 500);
                $this.showInstoreRepairMap();

            } else if (window.state.selectedservice == "KISS") {

                $this.scrollToRepairBookingSection('#repair-request-form');
                //$this.scrollTo('#repair-booking-form', 500);
                $this.showBookingRepairForm();

            } else {
                //console.log('this ran');
                $this.showSamsungMembersCTA();
                /*$('#klanabanner').hide();
                $('#screen-repair-banner').hide();
                $('#repair-options-header').hide();
                $('#repair-options').hide();

            }*/
      });

    $("#repair-steps-back-btn")
      .off("click")
      .on("click", function (e) {
        e.preventDefault();
        $this.hideRepairSteps("Prev-repair-solutions");

        if (window.state.availableservice == "PS") {
          $this.scrollTo("#products-section", 500);
        } else {
          $this.scrollTo("#repair-solutions", 100);
        }
      });

    $("#tvOutDays")
      .off("click")
      .on("click", function (e) {
        e.preventDefault();
        $("#repair-solutions").html("");
        $("#repair-solutions").hide();
        $this.checkAvailableRepairServiceList();
        $this.scrollTo("#repair-solutions", 100);
      });

    $("#tvInDays")
      .off("click")
      .on("click", function (e) {
        e.preventDefault();
        window.state.selectedservice = "KISS";
        $this.checkAvailableRepairServiceList();
      });

    $("#ub-back-btn")
      .off("click")
      .on("click", function (e) {
        e.preventDefault();
        $this.checkAvailableRepairServiceList();
        $this.scrollTo("#repair-solutions", 100);
      });

    $("#doorsteprepaircta a:nth-child(1)")
      .off("click")
      .on("click", function (e) {
        e.preventDefault();
        $this.hideRepairSteps("Prev-repair-solutions");
        $this.scrollTo("#repair-solutions", 100);
      });

    $("#sa-login-back-btn")
      .off("click")
      .on("click", function (e) {
        e.preventDefault();
        $("#sa-login").hide();
        $this.handleClickedContactUs();
      });

    $("#closeResolved")
      .off("click")
      .on("click", function (e) {
        e.preventDefault();
        $this.scrollTo("#choose-your-product", 100);
        $("#issue-resolved").hide();
        $("#troubleshooting-guide").html("");
        $("#troubleshooting-guide").hide();
      });

    /** Kiss Events **/

    $("#backToProducts")
      .off("click")
      .on("click", function (e) {
        e.preventDefault();
        $this.scrollTo("#products-section", 500);
        $("#purchaselocator").hide();
        $("#placeOfPurchase").trigger("reset");
      });

    $("input[type='radio'][name='location']").on("change", function () {
      var selectedRetailer = $(this).val();
      var dataOmniStr =
        "KISS Phase 1:selected_retailer:" + selectedRetailer + "_confirm";
      $("#confirmSelection").attr("data-omni", dataOmniStr);
      $("#confirmSelection").attr("ga-la", dataOmniStr);
      $("#confirmSelection").show();
    });

    $("#confirmSelection")
      .off("click")
      .on("click", function (e) {
        e.preventDefault();
        let $this = this;
        openChat = false;
        // console.log(" chat select-> " + openChat);

        var selectedVal = "";
        var selected = $("input[type='radio'][name='location']:checked");
        console.log(selected.val());

        if (selected.val() != "samsungcom") {
          // hide the locations form
          $("#purchaselocator").hide();
          $("#contact-dialogue").show();
          $("#contact-dialogue #is-samsung").hide();
          $("#contact-dialogue #is-not-samsung").show();
          //temp fix - win 10 edge is showing two dialogues

          // opens contact dialog for purchases on other retailers
        } else if (selected.val() == "samsungcom") {
          // hide the locations form
          // open contact dialog for purchases on SAMSUNGCOM

          $("#purchaselocator").hide();
          $("#contact-dialogue").show();
          $("#contact-dialogue #is-not-samsung").hide();
          $("#contact-dialogue #is-samsung").show();
        } else {
          alert("please choose a retailer");
        }
      });

    $("#contact-dialogue .go-back")
      .off("click")
      .on("click", function (e) {
        e.preventDefault();
        $this.hideConctactDialogue();
        $("#purchaselocator").show();
      });

    $("#contact-dialogue .start-chat")
      .off("click")
      .on("click", function (e) {
        e.preventDefault();
        // window.sprChat("open");
        let $this = this;
        // console.log(" chat button-> " + openChat);
        if (!openChat) {
          window.sprChat("openNewConversation");
          openChat = true;
        } else {
          window.sprChat("open");
        }
      });
  }

  kissEvents() {
    /** Kiss Events **/
    var $this = this;
    var openChat = false;

    $("#backToProducts")
      .off("click")
      .on("click", function (e) {
        e.preventDefault();
        $this.scrollTo("#products-section", 500);
        $("#purchaselocator").hide();
        $("#placeOfPurchase").trigger("reset");
      });

    $("input[type='radio'][name='location']").on("change", function () {
      var selectedRetailer = $(this).val();
      var dataOmniStr =
        "KISS Phase 1:selected_retailer:" + selectedRetailer + "_confirm";
      $("#confirmSelection").attr("data-omni", dataOmniStr);
      $("#confirmSelection").attr("ga-la", dataOmniStr);
      $("#confirmSelection").show();
    });

    $("#confirmSelection")
      .off("click")
      .on("click", function (e) {
        e.preventDefault();
        let $this = this;
        openChat = false;
        // console.log(" chat select-> " + openChat);

        var selectedVal = "";
        var selected = $("input[type='radio'][name='location']:checked");

        if (selected.val() != "samsungcom") {
          // hide the locations form

          $("#purchaselocator").hide();
          $("#contact-dialogue").show();
          //temp fix - win 10 edge is showing two dialogues
          $("#contact-dialogue #is-samsung").hide();
          $("#contact-dialogue #is-not-samsung").show();

          // opens contact dialog for purchases on other retailers
        } else if (selected.val() == "samsungcom") {
          // hide the locations form
          // open contact dialog for purchases on SAMSUNGCOM

          $("#purchaselocator").hide();
          $("#contact-dialogue").show();
          $("#contact-dialogue #is-not-samsung").hide();
          $("#contact-dialogue #is-samsung").show();
        } else {
          alert("please choose a retailer");
        }
      });

    $("#contact-dialogue .start-chat")
      .off("click")
      .on("click", function (e) {
        e.preventDefault();
        // window.sprChat("open");
        let $this = this;
        // console.log(" chat button-> " + openChat);
        if (!openChat) {
          window.sprChat("openNewConversation");
          openChat = true;
        } else {
          window.sprChat("open");
        }
      });

    $("#contact-dialogue .go-back")
      .off("click")
      .on("click", function (e) {
        e.preventDefault();
        $this.hideConctactDialogue();
        $("#purchaselocator").show();
      });

    $("#continue-repair")
      .off("click")
      .on("click", function (e) {
        e.preventDefault();
        $this.hideRepairSteps();
        $this.showSamsungMembersCTA();
      });

    $("#repair-steps-back-btn")
      .off("click")
      .on("click", function (e) {
        e.preventDefault();
        $this.hideRepairSteps("Prev-repair-solutions");

        if (window.state.availableservice == "PS") {
          $this.scrollTo("#products-section", 500);
        } else {
          $this.scrollTo("#choose-your-product", 100);
        }
      });
  }

  tvavExtra() {
    $(document).on("click", ".TVAV-3", function (e) {
      e.preventDefault();
      $([document.documentElement, document.body]).animate(
        {
          scrollTop:
            $("#harman-jbl-akg").offset().top -
            $(".floating-navigation__wrap").height() * 2,
        },
        500
      );
    });
  }

  repairBookingFormListener(mutationList, observer) {
    var $this = this;

    mutationList.forEach(function (mutation) {
      //const elementId = mutation.target.id;

      if (
        mutation.type === "attributes" &&
        mutation.attributeName === "style"
      ) {
        //var scrollTop = $('#'+elementId).position().top - 20;

        var stepsSummaryHeight = $(".steps-wrapper").outerHeight() + 20;

        stepsSummaryHeight += $(".floating-navigation").hasClass(
          "floating-navigation--fixed"
        )
          ? 0
          : $(".steps-wrapper").outerHeight();

        stepsSummaryHeight += $(".summary-wrapper").is(":visible")
          ? $(".summary-wrapper").outerHeight()
          : 0;
        var scrollTop =
          $("#repair-booking-form").position().top - stepsSummaryHeight;
        $("html, body").animate(
          {
            scrollTop: scrollTop,
          },
          500,
          function () {}
        );
      }
    });
  }

  scrollToRepairBookingSection(sectionId) {
    var $this = this;

    /** Code to observe repair booking form **/
    const repairBookingForm = document.querySelector(sectionId);
    const options = {
      attributes: true,
    };
    const observer = new MutationObserver($this.repairBookingFormListener);
    observer.observe(repairBookingForm, options);
  }

  /*repairBookingFormListener(mutationList, observer) {

        var $this = this;

        mutationList.forEach( function(mutation) {

            if (mutation.type === 'attributes' && mutation.attributeName === 'style') {

                var scrollTop = $($this.repairBookingFormId).position().top - 20;

                $('html, body').animate({
                        scrollTop: scrollTop
                    }, 500, function () {
                    }
                );

            }

        });

    }



    scrollToRepairBookingSection(sectionId) {

        var $this = this;

        /** Code to observe repair booking form **
        $this.repairBookingFormId = sectionId;
        const repairBookingForm = document.querySelector(sectionId);
        console.log(repairBookingForm);
        const options = {
            attributes: true
        }
        const observer = new MutationObserver($this.repairBookingFormListener);
        observer.observe(repairBookingForm, options);

    }*/

  getUBPriceProductAndSetProductImage() {
    var $this = this;

    var url =
      "https://samsung-repair-prices.s3.eu-west-2.amazonaws.com/mobile/";
    var fileName =
      window.location.host == "www.samsung.com"
        ? "repair-prices-by-model.json"
        : "repair-prices-by-model-new.json";
    var cacheBustor = Math.floor(Math.random() * 1000000000);
    fileName = fileName + "?v=" + cacheBustor;

    url = url + fileName;

    var ubModels = [];

    $.get(url, function (data) {
      for (var x = 0; x < data.devices.length; x++) {
        var entry = data.devices[x];
        var ubPrice = entry["ubprice"].trim();
        var rpScreen = entry["screen"].trim();

        if (ubPrice != "") {
          ubModels.push({
            //model:entry["devicemodel"],
            model: entry["devicename"],
            rrp: rpScreen,
            ubrrp: ubPrice,
          });
        }
      }
    });

    return ubModels;
  }

  checkAvailableRepairServiceList() {
    // console.log("tvInDays checkAvailableRepairServiceList");
    var $this = this;

    // If this is a battery replacement journey, set the appropriate services
      if (window.state.isBatteryReplacement) {
        // For battery replacement, we only want to show in-store service
        var asList = ["ISR"]; // In-store repair only

        // Handle available service list with battery replacement context
        $this.handleAvailableServiceList(asList);
        return; // Exit early
      }

    // Available service is set inside the troubleshooter.js according to the category
    var availableService = window.state.availableservice;
    var asList = availableService.split("|");

    if (
      !window.state.ispmnotavailable && 
      site == "uk" &&
      window.state._availableservice != "IHTVDA" &&
      window.state._availableservice != "PSTVDA"

    ) {
      var url =
        "https://samsung-repair-prices.s3.eu-west-2.amazonaws.com/stores/";
      var fileName =
        window.location.host == "www.samsung.com"
          ? "repair-solution-product-mapping-live.json"
          : "repair-solution-product-mapping.json";
      var cacheBustor = Math.floor(Math.random() * 1000000000);
      fileName = fileName + "?v=" + cacheBustor;

      url = url + fileName;

      $.get(url, function (data) {
        var rspm = data.rspm;
        var tsProduct = window.state.tsoutcome.troubleshootedProduct
          .split("/")[1]
          .toLowerCase()
          .replace(/ /g, "")
          .replace("+", "plus")
          .replace("wi-fi", "wifi");

        $.each(rspm, function (key, availableRspm) {
          var product = availableRspm.product.toLowerCase();
          product = product.replace(/ /g, "");
          product = product.replace("+", "plus");
          product = product.replace("wi-fi", "wifi");
          // console.log("tvInDays ", availableRspm);
          // console.log(tsProduct, 'tsProduct Test')
          // console.log(product, 'product Test')

          if (product == tsProduct) {
            asList = [];

            if (availableRspm.doorstep) {
              asList.push("DSR");
            }
            if (availableRspm.pickup) {
              asList.push("PS");
            }
            if (availableRspm.instore) {
              asList.push("ISR");
            }
            if (availableRspm.inhome) {
              asList.push("IH");
            }
            if (window.state.availableservice == "PSTV") {
              asList = [];
              asList.push("PSTV");
            }
            // if (availableRspm.tradein) {
            //   asList.push("TRIN");
            // }

            //console.log(asList);

            return;

            // return asList;

            // return asList;
          }
        });
      })
        .fail(function () {
          //console.log('Failed to access repair solution mapping');
          $this.handleAvailableServiceList(asList);
        })
        .done(function () {
          //console.log('Get repair solution mapping Success');
          $this.handleAvailableServiceList(asList);
        });
    } else {

      if (window.state._availableservice === "IHTVDA") {
        asList = [];
        asList.push("IHTVDA");
      }

      if (window.state._availableservice === "PSTVDA") {
        asList = [];
        asList.push("PSTVDA");
      }
      // ********* IE overrides subservices **************

      let tvavPickupRepairProducts = [
        "Samsung/UBD-K8500",
        "Samsung/HW-J651Soundbar",
        "Samsung/TheFreestyle",
      ];

      // if (
      //   site === "ie" &&
      //   window.state.category === "tvav" && 
      //   tvavPickupRepairProducts.includes(
      //     window.state.tsoutcome.troubleshootedProduct
      //   ) 
      // ) {
      //   asList = ["PS"];
      // } 

      // IE TV selected set as PSTV
      // if (
      //   site === "ie" &&
      //   window.state.category === "tvav" &&
      //   window.state.tsoutcome.troubleshootedProduct === 'Samsung/Televisions' ||
      //   site === "ie" &&
      //   window.state.category === "tvav" &&
      //   window.state._product === "AV"
      // ) {
      //   asList = ["PSTV"];
      // }

       // ********* IE overrides subservices END **************

      // If the products not configured in Product mapping got multiple serivice
      // console.log("tvInDays", asList);
      $this.handleAvailableServiceList(asList);
    }
  }

  handleAvailableServiceList(asList) {
    var $this = this;

    // console.log("tvInDays in handle -> ", asList);

    // If the user troubleshooted with KISS or there is no selected service don't show service section
    if (asList.length >= 1 && window.state.selectedservice != "KISS") {
      $("#care-plus-repair").hide();
      $("#troubleshooting-guide").hide();
      // console.log("tvInDays handleAvailableServiceList IF");
      $this.drawRepairServiceSection(asList);
    } else {
      // console.log("tvInDays handleAvailableServiceList ELSE");
      $this.handleClickedServiceType(window.state.availableservice);
    }
  }

  hideConctactDialogue() {
    $("#contact-dialogue").hide();
    $("#contact-dialogue #is-samsung").hide();
    $("#contact-dialogue #is-not-samsung").hide();
    window.sprChat("close");
  }

  tsEvents() {
    var $this = this;
    this.openChat = false;

    if (window.addEventListener) {
      window.addEventListener("message", function (e) {
        e.stopPropagation();
        $this.receiver(e);
        $this.kissEvents();
      });
    } else {
      window.attachEvent("onmessage", function (e) {
        e.stopPropagation();
        $this.receiver(e);
      });
    }
  }

  receiver(event) {
    // console.log("Inside receiver");

    let postedData = event.data;
    let $this = this;

    if (typeof postedData == "object" && postedData.type != undefined) {
      switch (postedData.type.toLowerCase()) {
        case "lcxcontentheight":
          $this.handleIframeHeight(postedData);
          break;

        case "tsoutcome":
          $this.handleTsOutcome(postedData);
          break;

        case "clickedcontactus":
          $this.handleClickedContactUs();
          break;

        case "lcxtsmessage":
          $this.handleTsMessage(postedData);
          break;

        case "clickedchattoagent":
          // console.log("chat -> interpreter " + this.openChat);
          // console.log("chat -> mobile");
          // console.log("_c_656090b343743730688d8a00 -> Yes");
          // console.log("_c_65771084f23a9b229d7cc53c -> " + window.state.product);
          window.sprChat("updateClientContext", {
            _c_656090b343743730688d8a00: ["Yes"], //Mobile Yes or No
            _c_656090f243743730688db608: ["No"], //HA Yes or No
            _c_6560912b43743730688ddf16: ["No"], //TV Yes or no
            _c_6560915e43743730688e084d: ["No"], //Computer Yes or no
            // sub categroy
            _c_65771084f23a9b229d7cc53c: [window.state.product],
            _c_657710b3f23a9b229d7d07cf: [""],
            _c_657710f2f23a9b229d7d6824: [""],
            _c_65771135f23a9b229d7dd8c0: [""],
            // filter value for reports
            _c_65a7cc9c3bd1664f2fdcfaa6: ["Yes"],
          });
          if (!this.openChat) {
            // console.log("chat if");
            window.sprChat("updateClientContext", {
              _c_647484e02b41c27ed4ed9a54: ["Yes"], //Key - custom field name, Value - Blank
            });

            window.sprChat("openNewConversation", {
              initialMessages: [
                {
                  message: "Hi, I want to speak to a Samsung Support Expert",
                  isSentByUser: true,
                },
              ],
            });
          } else {
            console.log("chat else");
            window.sprChat("open");
          }
          this.openChat = true;

          break;
      }
    }
  }

  handleIframeHeight(postedData) {
    let height = postedData.clientHeight;
    let $this = this;

    if (height != $this.currentiFrameHeight) {
      $this.currentiFrameHeight = height;

      //change the iFrame height
      $("#iframe").css("height", height);
      $this.scrollTo("#troubleshooting-guide", 500);
    }
  }

  handleClickedContactUs() {
    let $this = this;

    // Check if this is a battery replacement journey first
    if (window.state.isBatteryReplacement) {
      // Skip Care+ check and go straight to the repair option
      window.supportComponents.steps.setActiveStep(3);
      const stepTexts = document.querySelectorAll("support-steps p");
       stepTexts.forEach(function (p) {
          switch (p.textContent) {
            case "Book your repair":
              p.textContent = "Book your appointment";
              break;
            case "Repair summary":
              p.textContent = "Appointment summary";
              break;
          }
        });
      // Set the service type to In-store Repair for battery replacement
      window.state.selectedservice = "ISR";

      // Skip days confirmation and go straight to available repair options
      $this.checkAvailableRepairServiceList();
      return; // Exit early
    }

    if (this.lucidSuccess != true) {
      $("#troubleshooting-guide").html("");
      $("#troubleshooting-guide").hide();

      if (site == "uk" && window.state.category == "mobile") {
        // console.log('did this run')
        $("#care-plus-repair").show();
        $this.scrollTo("#care-plus-repair", 100);
      } else {
        // console.log("clicked contact us");
        window.supportComponents.steps.setActiveStep(3);
        if (
          (window.state.product == "TV" && site != "ie") ||
          (window.state.product == "AV" && site != "ie")
        ) {
          $this.drawDaysConfirmation();
        } else {
          $this.checkAvailableRepairServiceList();
        }
      }
    } else {
      this.redirectToContact();
    }
  }

  handleClickedContactUs1() {
    let $this = this;

    if (this.lucidSuccess != true) {
      /** P6 AEM comoponents **/
      $("#mobile-door-step-repair-steps").hide();
      $("#pickup-repair-steps").hide();
      $("#ha-pickup-repair-steps").hide();
      $("#mobile-instore-repair-steps").hide();
      $("#in-home-repair-steps").hide();
      $("#ps-in-home-repair-steps").hide();
      $("#kiss-in-home-repair-steps").hide();
      $("#kiss-ii-in-home-repair-steps").hide();
      $("#doorsteprepaircta").hide();
      $("#dsr-surcharge-txt").hide();
      $("#twentyeightdayscontact").hide();

      $("#troubleshooting-guide").html("");
      $("#troubleshooting-guide").hide();

      /** Configure here if a TVAV products are used as Pickup repair **/
      // let tvavPickupRepairProducts = ["Samsung/UBD-K8500", "Samsung/HW-J651Soundbar", "Samsung/TheFreestyle"];

      /** Configure here if a Vacuum cleaners products are used as Pickup repair **/
      // let vacuumCleanersPickupRepairProducts = ["Samsung/BespokeJetVacuumCleaner", "Samsung/VC4000CanisterVacuum", "Samsung/Jet75Pet", "Samsung/Jet70Turbo", "Samsung/VU3000Vacuum"];

      /** P6 component some times setting desc section height to 0, because of that image and text overlap happens some time to avoid that following
            lines of javascript written to remove the zero height set by the component **/
      $("#mobile-door-step-repair-steps .feature-multi-column__image").height(
        "auto"
      );
      $("#pickup-repair-steps .feature-multi-column__image").height("auto");
      $("#ha-pickup-repair-steps .feature-multi-column__image").height("auto");
      $("#mobile-instore-repair-steps .feature-multi-column__image").height(
        "auto"
      );
      $("#in-home-repair-steps .feature-multi-column__image").height("auto");
      $("#ps-in-home-repair-steps .feature-multi-column__image").height("auto");
      $("#kiss-in-home-repair-steps .feature-multi-column__image").height(
        "auto"
      );
      $("#kiss-ii-in-home-repair-steps .feature-multi-column__image").height(
        "auto"
      );

      // Reset UbPrice flag every time come out from the T/S
      window.state.isUBPrice = false;

      //console.log('');
      if (window.state.category == "tvav") {
        if (window.state.selectedservice == "PSIH") {
          $("#ps-in-home-repair-steps").show();
        } else if (window.state.selectedservice == "PS") {
          $("#pickup-repair-steps").show();
        } else {
          $("#in-home-repair-steps").show();
        }
      } else if (window.state.category == "homeappliance") {
        if (window.state.selectedservice == "PS") {
          $("#ha-pickup-repair-steps").show();
        } else if (window.state.selectedservice == "KISS") {
          // Door replacement
          if (window.state.tsoutcome.outcome == "ihIIbooking") {
            $("#kiss-ii-in-home-repair-steps").show();
          } else {
            $("#kiss-in-home-repair-steps").show();
          }
        } else {
          $("#in-home-repair-steps").show();
        }
      } else if (window.state.category == "itrepair") {
        if (window.state.selectedservice == "PSIH") {
          $("#ps-in-home-repair-steps").show();
        } else if (window.state.selectedservice == "IH") {
          $("#in-home-repair-steps").show();
        } else {
          $("#pickup-repair-steps").show();
        }
      } else if (window.state.category == "mobile") {
        $("#pickup-repair-steps").show();
      }

      if (window.state.selectedservice == "KISS") {
        // Door replacement
        if (window.state.tsoutcome.outcome == "ihIIbooking") {
          $("#repair-title").html("Booking an appointment");
        } else {
          $("#repair-title").html("Booking an inspection");
        }
      } else {
        $("#repair-title").html("Booking your repair");
        $("#pickup-repair-steps .feature-multi-column__title-text").html(
          "Booking your repair"
        );
      }

      // Show the Continue repair and back button below the repair
      $("#continue-repair-back-btns").show();
      this.scrollTo("#stepstorepair", 500);
    } else {
      this.redirectToContact();
    }
  }

  handleClickedChatToAgent(postedData) {
    let $this = this;
    if (openChat) {
      window.sprChat("updateClientContext", {
        _c_647484e02b41c27ed4ed9a54: ["Yes"], //Key - custom field name, Value - Blank
      });

      window.sprChat("openNewConversation", {
        initialMessages: [
          {
            message: "Hi, I want to speak to a Samsung Support Expert",
            isSentByUser: true,
          },
        ],
      });
    } else {
      window.sprChat("open");
    }
  }

  // // TEMP FIX - this function
  // handleClickedChatToAgentMX(postedData) {
  //   window.sprChat("updateClientContext", {
  //     _c_647484e02b41c27ed4ed9a54: ["Yes"], //Key - custom field name, Value - Blank
  //   });

  //   window.sprChat("open");

  //   window.sprChat("openNewConversation", {
  //     initialMessages: [
  //       {
  //         message: "Hi, I want to speak to a Samsung Support Expert",
  //         isSentByUser: true,
  //       },
  //     ],
  //   });
  // }

  hideRepairSteps(prev = "") {
    // window.state.isBatteryReplacement = false;
    /** P6 AEM comoponents **/
    // $('#mobile-door-step-repair-steps').hide();
    $("#doorsteprepaircta").hide();
    $("#dsr-surcharge-txt").hide();
    $("#mobile-pickup-repair-steps").hide();
    // $('#mobile-instore-repair-steps').hide();
    // $('#ha-pickup-repair-steps').hide();
    // $('#pickup-repair-steps').hide();
    // $('#in-home-repair-steps').hide();
    // $('#ps-in-home-repair-steps').hide();
    // $('#kiss-in-home-repair-steps').hide();
    // $('#kiss-ii-in-home-repair-steps').hide();
    $("#repair-request-form").hide();
    $("#instore-repair-map").hide();
    $("#sa-login").hide();

    if (prev) {
      $("#repair-solutions").show();
    } else {
      $("#repair-solutions").hide();
    }

    //$('#sa-login .banner-wrapper').hide();
    //$('#sa-login #sa-login-back-btn').hide();

    $("#troubleshooting-guide").html("");
    $("#troubleshooting-guide").hide();

    // hide continue repair and back to previous step buttons
    $("#continue-repair-back-btns").hide();

    $("#general-repair-steps").hide();
  }

  // Needs to be deleted it's not required or it needs to be called from handleClickedContactUs method
  showRepairSteps() {
    /** Configure here if a TVAV products are used as Pickup repair **/
    let tvavPickupRepairProducts = [
      "Samsung/UBD-K8500",
      "Samsung/HW-J651Soundbar",
      "Samsung/TheFreestyle",
    ];

    this.hideRepairSteps();

    /** P6 component some times setting desc section height to 0, because of that image and text overlap happens some time to avoid that following
        lines of javascript written to remove the zero height set by the component **/
    // $('#mobile-door-step-repair-steps .feature-multi-column__image').height('auto');
    // $('#pickup-repair-steps .feature-multi-column__image').height('auto');
    // $('#ha-pickup-repair-steps .feature-multi-column__image').height('auto');
    // $('#mobile-instore-repair-steps .feature-multi-column__image').height('auto');
    // $('#in-home-repair-steps .feature-multi-column__image').height('auto');
    // $('#kiss-in-home-repair-steps .feature-multi-column__image').height('auto');
    // $('#kiss-ii-in-home-repair-steps .feature-multi-column__image').height('auto');

    //console.log('');
    if (window.state.category == "tvav") {
      if (
        tvavPickupRepairProducts.indexOf(
          window.state.tsoutcome.troubleshootedProduct
        ) != -1
      ) {
        $("#pickup-repair-steps").show();
      } else {
        $("#in-home-repair-steps").show();
      }
    } else if (window.state.category == "homeappliance") {
      if (window.state.product == "Floorcare") {
        $("#ha-pickup-repair-steps").show();
      } else if (window.state.selectedservice == "KISS") {
        // Door replacement
        if (window.state.tsoutcome.outcome == "ihIIbooking") {
          $("#kiss-ii-in-home-repair-steps").show();
        } else {
          $("#kiss-in-home-repair-steps").show();
        }
      } else {
        $("#in-home-repair-steps").show();
      }
    } else if (window.state.category == "itrepair") {
      $("#pickup-repair-steps").show();
    } else if (window.state.category == "mobile") {
      $("#pickup-repair-steps").show();
      // $('#pickup-repair-steps .feature-multi-column__title-text').html('Step 4. Booking your repair');
    }

    // show continue repair and back to previous step buttons
    $("#continue-repair-back-btns").show();

    setTimeout(function () {
      window.dispatchEvent(new Event("resize"));
      $("#mobile-door-step-repair-steps .feature-multi-column__image").height(
        "auto"
      );
      $("#pickup-repair-steps .feature-multi-column__image").height("auto");
      $("#mobile-instore-repair-steps .feature-multi-column__image").height(
        "auto"
      );

      $("#ha-pickup-repair-steps .feature-multi-column__image").height("auto");
      $("#in-home-repair-steps .feature-multi-column__image").height("auto");
      $("#kiss-in-home-repair-steps .feature-multi-column__image").height(
        "auto"
      );
      $("#kiss-ii-in-home-repair-steps .feature-multi-column__image").height(
        "auto"
      );
    }, 500);
  }

  handleTsOutcome(postedData) {
    // console.log("handleTsOutcome", postedData);
    /**"notresolved", "otherissue" ->product faulty

        "notresolved" - > help with installation

        "otherdeliverydamage" - > Delivery damage **/

    let $this = this;

    let tsOutcome = {};

    if (window.state.isBatteryReplacement ||
      (postedData.selectedIssue && postedData.selectedIssue === "Battery Replacement")) {

      // Set the flag if not already set
      window.state.isBatteryReplacement = true;

    }

    /** Same set of array used in apiRequests.js file to update serviceType and subServiceType **/
    let tsOutComeListToCallUs = [
      "ihkissbooking",
      "ihIIbooking",
      "resolved",
      "notresolved",
      "wheredidyoubuy",
      "doorreplacementrequested",
      "doorreplacementdeclined",
      "otherdeliverydamage",
      "missingdamaged",
      "otherissue",
    ];

    let outcome = postedData.outcome; //Successful or Unsuccessful or Skipped
    // console.log("handleTsOutcome outcome", outcome);

    if (outcome.toLowerCase() == "successful") {
      $this.lucidSuccess = true;
    } else {
      $this.lucidSuccess = false;
    }

    let lucidRef = postedData.sessionId;

    var isCallUsOutcome =
      $.inArray(outcome, tsOutComeListToCallUs) !== -1 ? true : false;

    // console.log('Lucid ref', lucidRef);

    // console.log('Lucid ref exits', lucidRef=='');

    //console.log(outcome);
    //start of CallToUS outcome
    if (
      (lucidRef == "" && outcome != "ihkissbooking") ||
      outcome == "resolved" ||
      outcome == "ihIIbooking" ||
      outcome == "otherissue"
    ) {
      // ihkissbooking
      $this.handleTsMessage(postedData);
    } else {
      if (outcome == "Skipped") {
        lucidRef += "-SKIP";
      }

      // Pickup
      tsOutcome["lucidRef"] = lucidRef ? lucidRef : window.state._tsRef;
      tsOutcome["outcome"] = outcome;
      tsOutcome["symptomCode1"] = postedData.symptomCode1;
      tsOutcome["symptomCode2"] = postedData.symptomCode2;
      tsOutcome["symptomCode3"] = postedData.symptomCode3;
      tsOutcome["warrantyException"] = postedData.warrantyException;
      tsOutcome["selectedIssue"] = postedData.selectedIssue;

      let tsProduct = postedData.product;
      var productListNotHandledByTS = [
        "TV",
        "Refrigerator",
        "Laundry",
        "Cooking",
        "Dishwashers",
        "Monitor",
        "Galaxy Book",
      ];
      //var products

      $this.troubleshootedProduct = "";
      tsOutcome["troubleshootedProduct"] = "";

      if ("product" in postedData) {
        $this.troubleshootedProduct = postedData.product;
        tsOutcome["troubleshootedProduct"] = postedData.product;

        // console.log(window.state.product);
        // console.log(
        //   $.inArray(window.state.product, productListNotHandledByTS) !== -1
        // );

        if ($.inArray(window.state.product, productListNotHandledByTS) !== -1) {
          tsOutcome["tsProductNameForDisplay"] = window.state.product;
        } else {
          var productNameForDisplay = tsProduct
            .split("/")[1]
            .replace("5G", "Fiveg")
            .replace("4G", "Fourg");
          productNameForDisplay = productNameForDisplay.replace(
            /([A-Z])/g,
            " $1"
          );
          productNameForDisplay = productNameForDisplay
            .replace("Fiveg", "5G")
            .replace("Fourg", "4G");
          productNameForDisplay = productNameForDisplay.replace(" Plus", "+");
          productNameForDisplay = productNameForDisplay.replace("20", " 20");
          productNameForDisplay = productNameForDisplay.replace("8.", " 8.");
          productNameForDisplay = productNameForDisplay.replace("9.", " 9.");
          productNameForDisplay = productNameForDisplay.replace("10.", " 10.");
          productNameForDisplay = productNameForDisplay.replace(
            "Ovens",
            "Ovens "
          );
          productNameForDisplay = $.trim(productNameForDisplay);

          // tsOutcome['tsProductNameForDisplay'] = $.trim(tsProduct.split('/')[1].replace("5G", "Fiveg").replace(/([A-Z])/g, " $1").replace("Fiveg", "5G"));
          tsOutcome["tsProductNameForDisplay"] = productNameForDisplay;
        }
      }

      // TS has the product Image
      if (
        $.inArray(window.state.product, [
          "Tablets",
          "Wearables",
          "Vacuum Cleaners",
          "Projector",
          "AV",
        ]) !== -1
      ) {
        if ($.inArray(window.state.product, ["Wearables"]) !== -1) {
          window.state.productImage =
            tsProduct
              .split("/")[1]
              .toLowerCase()
              .replace(".", "point")
              .replaceAll(" ", "") + ".png";
        } else {
          window.state.productImage =
            tsProduct.split("/")[1].toLowerCase().replace(".", "point") +
            ".jpg";
        }
      } else if (window.state.product == "Smartphones") {
        window.state.productImage =
          tsProduct.split("/")[1].toLowerCase().replace(".", "point") + ".jpg";
      }

      window.state.tsoutcome = tsOutcome;

      $this.setRepairSummary();

      var tsSessionRef = "";

      // console.log("Outcome", outcome);

      setTimeout(function () {
        if (outcome.toLowerCase() == "successful") {
          $this.lucidSuccess = true;
        } else {
          if ($this.troubleshootedProduct.indexOf("Samsung/GalaxyTabS8") >= 0) {
            /**  Galaxy Tab S8 products only pickup service available **/
            window.state.availableservice = "PS";
          } else if (
            tsProduct == "Samsung/GalaxyZFlip35G" ||
            tsProduct == "Samsung/GalaxyZFold35G"
          ) {
            /** Above Galaxy fold and filip product repair not available **/
            //$this.lucidSuccess = true;

            $this.flip3fold3 = true;
          } else {
            $this.flip3fold3 = false;
          }

          $this.lucidSuccess = false;

          // Add the lucid outcode to session ...
          var form = new FormData();
          form.append("caseID", tsOutcome["lucidRef"]);
          form.append("defect1", tsOutcome["symptomCode1"]);
          form.append("defect2", tsOutcome["symptomCode2"]);
          form.append("defect3", tsOutcome["symptomCode3"]);
          form.append("damageRef", tsOutcome["warrantyException"]);

          //Add troubleshooter ref to maintenance message
          $(".maintenance .mm-lucidref").html(tsOutcome["lucidRef"]);
          $(".maintenance .btn-container a").attr(
            "ga-la",
            function (index, currentAttrValue) {
              return (
                currentAttrValue +
                " " +
                window.state.category +
                " " +
                window.state.product
              );
            }
          );

          /*for (var value of form.values()) {
                        $this.doLog(value);
                    }*/

          //window.state.ismaintenanceflagon = true;

          var host = window.state.apihost;

          var path = "/uk/repair-booking/";

          var url = host + path + "igspn.php";

          var settings = {
            url: url,
            data: form,
            processData: false,
            contentType: false,
            dataType: "json",
            type: "POST",
          };

          $.ajax(settings)
            .done(function (response) {
              if (response.success == true) {
                tsOutcome["tsSessionRef"] = response.reference;
                window.state.tsoutcome = tsOutcome;
                //console.log(JSON.stringify(tsOutcome));

                window.state.ismaintenanceflagon =
                  response.show_maintenance_message;
                if (isCallUsOutcome) {
                  window.state.selectedservice = "KISS";
                  $this.handleClickedContactUs();
                }
              }
            })
            .fail(function () {
              console.log("TSS fail");
            });
        }
      }, 10);
    }

    // End of CallToUS outcome else
  }

  setRepairSummary() {
    $("#repair_summary").attr(
      "device-name",
      window.state.tsoutcome.tsProductNameForDisplay
    );
    $("#repair_summary").attr(
      "reference-number",
      window.state.tsoutcome.lucidRef
    );
    $("#repair_summary").attr(
      "repair-type",
      window.state.tsoutcome.selectedIssue
    );
    $("#repair_summary").show();

    /**id="repair_summary"
        device-name=""
        reference-number=""
        repair-type=""
        repair-description=""
        appointment-date=""
        appointment-time=""
        appointment-location=""
        appointment-type=""*/
  }

  handleTsMessage(postedData) {
    let issue = postedData.outcome;
    let replaceRef = postedData.sessionId;

    //console.log('ref is' + replaceRef);
    if (replaceRef == null || replaceRef == "") {
      $(".ref-hide").hide();
      $(".noref-hide").show();
    } else {
      $(".ref-hide").show();
      $(".noref-hide").hide();
    }

    $("#troubleshooting-guide").html("");
    $("#troubleshooting-guide").hide();

    if (issue == "resolved") {
      $("#purchaselocator").hide();
      $("#contact-dialogue").hide();
      $("#issue-resolved").show();
      this.scrollTo("#issue-resolved", 400);

      if (typeof ga === "function") {
        ga("create", this.gaId, {
          name: "gtm8888",
          cookieExpires: "33696000",
          cookieDomain: "auto",
        });
        ga("gtm8888.send", {
          hitType: "event",
          eventCategory: "repair",
          eventAction: "booking",
          eventLabel: "KISS Phase 1: Yes All Resolved",
        });
      }

    } else {
      if (site == "ie") {
        // For Kiss troubleshooter urls use below code
        //$('#contact-dialogue').show();
        //$('#contact-dialogue #is-not-samsung').show();

        // For 28 days troubleshooter urls use below code
        if ($("#twentyeightdayscontact").length) {
          $("#twentyeightdayscontact").show();
        } else {
          $(".product-category").closest(".cheil-static").append(`
            <section id="twentyeightdayscontact" class="twentyeightdayscontact--custom">
              <div>
                <div class="twentyeightdayscontact__image">
                  <img src="//images.samsung.com/is/image/samsung/assets/uk/support/repair/Call-us.jpeg?$LazyLoad_Home_JPG$"/>
                </div>
                <div class="twentyeightdayscontact__content">
                  <h2>Please call us</h2>

                  <p>We can still help you</p>
                  <p>Mon - Fri | 8am to 8pm</p>
                  <p>Sat - Sun | 9am to 6pm</p>
                  <a class="cta cta--underline cta--black" href="Tel:0818717100" aria-label="0818 717 100" an-tr="co16_discover column new-microsite-content_click" an-ca="content click" an-ac="feature" an-la="please call us:0818 717 100">
										0818 717 100
									</a>
                </div>
              </div>
            </section>
          `);
        }

        this.scrollTo("#twentyeightdayscontact", 400);
        window.dispatchEvent(new Event("resize"));

        // for uk
      } else {
        $("#issue-resolved").hide();
        $("#purchaselocator").css("display", "flex");
        this.scrollTo("#purchaselocator", 400);

        $("#refCode #inner").text(replaceRef);
      }

      if (typeof ga === "function") {
        ga("create", this.gaId, {
          name: "gtm8887",
          cookieExpires: "33696000",
          cookieDomain: "auto",
        });
        ga("gtm8887.send", {
          hitType: "event",
          eventCategory: "repair",
          eventAction: "booking",
          eventLabel: "KISS Phase 1: No Still Need Help",
        });
      }
    }
  }

  /*handleTsMessage(postedData) {


        let issue = postedData.outcome;
        $('#twentyeightdayscontact').show();
        this.scrollTo('#twentyeightdayscontact', 400);

    }*/

  handleClickedServiceType(serviceType) {
    // console.log("tvInDays service type in function -> " + serviceType);
    this.hideRepairSteps();
    $("#general-repair-steps").show();

    $("#sa-login #repair-title").html("Book your repair");

    /** Booking form Step button element tagging changes according to the Selected repair option **/
    var stepsButtonElement = $("button[ga-la*='repair booking:']");
    var selectedservice;

    // console.log(
    //   "tvInDays service type in function  selected service-> " +
    //     window.state.selectedservice
    // );

    switch (window.state.selectedservice) {
      case "DSR":
        $("#repair_summary").attr("appointment-type", "Doorstep repair");

        selectedservice = "DSR";

        $("#doorsteprepaircta").show();

        if ($("#doorsteprepaircta").length) {
          $("#doorsteprepaircta").show();
          $("#doorsteprepaircta .s-btn-encased").attr("ga-ac", "feature");
          $("#doorsteprepaircta .s-btn-encased").attr("ga-ca", "repair");
          $("#doorsteprepaircta .s-btn-encased").attr(
            "ga-la",
            "mobile:doorstep repair_book a repair"
          );
        }

        $(window).trigger("resize");

        break;

      case "PS":
        $("#repair_summary").attr("appointment-type", "Pickup repair");

        if (window.state.category == "homeappliance") {
          if (window.state._product == "Vacuum Cleaners") {
            selectedservice = "HAPSVacuum";

            $("#continue-repair-back-btns").show();

            window.dispatchEvent(new Event("resize"));
          } else {
            selectedservice = "HAPS";

            $("#continue-repair-back-btns").show();

            window.dispatchEvent(new Event("resize"));
          }
        } else {
          selectedservice = "PS";

          $("#continue-repair-back-btns").show();

          window.dispatchEvent(new Event("resize"));
        }

        /** Code for tagging updated according to the selected option **/
        if (stepsButtonElement.length > 0) {
          stepsButtonElement.each(function () {
            var galaArray = $(this).attr("ga-la").split(":");
            var newTag =
              galaArray[0] +
              ":pickup repair:" +
              galaArray[galaArray.length - 1];

            $(this).attr("ga-la", newTag);
            $(this).attr("data-omni", newTag);
          });
        }

        break;

      case "ISR":
        $("#repair_summary").attr("appointment-type", "In-store repair");

        selectedservice = "ISR";
        $("#continue-repair-back-btns").show();
        window.dispatchEvent(new Event("resize"));

        if (stepsButtonElement.length > 0) {
          stepsButtonElement.each(function () {
            var galaArray = $(this).attr("ga-la").split(":");
            var newTag =
              galaArray[0] +
              ":In-store repair:" +
              galaArray[galaArray.length - 1];

            $(this).attr("ga-la", newTag);
            $(this).attr("data-omni", newTag);
          });
        }

        if (window.state._tsoutcome.selectedIssue == "Battery Replacement") {

            const observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
              if (mutation.addedNodes.length) {
              const generalRepairStepsTitle = document.querySelector("#general-repair-steps h4");
              const generalRepairStepsItems = document.querySelectorAll("#general-repair-steps .ts-steps-item");

              if (generalRepairStepsTitle) {
                generalRepairStepsTitle.innerText = "In-store Service";
              }

                if (generalRepairStepsItems.length) {
                  generalRepairStepsItems.forEach(function (item, index) {
                  if (index === 2) {
                    item.querySelector("p").innerText = "Once your device has been inspected, our Authorised Service Partner will confirm how long the battery replacement will take and how much it will cost.";
                  }
                  if (index === 3) {
                    item.querySelector("p").innerText = "Once the replacement is completed you will be contacted to confirm how you would like your device to be returned back to you.";
                  }
                  }); observer.disconnect();
                  }
                }
              });
            });

            observer.observe(document.querySelector("#general-repair-steps"), { childList: true, subtree: true });

        }

        /** code for maintenance message **/
        $(".maintenance").hide();

        if (window.state.ismaintenanceflagon) {
          $("#instore-repair-map .maintenance").show();
          //$('#instore-repair-map .maintenance .mm-lucidref').html(window.state.tsoutcome.lucidRef);
          $(".sl-map").hide();
        } else {
          $("#instore-repair-map .sl-map").show();
          $("#instore-repair-map .maintenance").hide();
        }

        break;

      case "IH":
        $("#repair_summary").attr("appointment-type", "In-home repair");
        selectedservice = "IH";

        $("#continue-repair-back-btns").show();
        window.dispatchEvent(new Event("resize"));

        break;

      case "PSTV":
        // console.log("tvInDays case PSTV ", window.state.tsoutcome.outcome);
        $("#repair_summary").attr("appointment-type", "");

        // selectedservice = window.state.product == "TV" ? "PSIHTV" : "PSIH";
        selectedservice = "PSIHTV";
        // console.log("tvInDays selectedservice", selectedservice);
        $("#continue-repair-back-btns").show();
        window.dispatchEvent(new Event("resize"));

        break;

      case "PSIH":
        $("#repair_summary").attr("appointment-type", "");

        selectedservice = window.state.product == "TV" ? "PSIHTV" : "PSIH";
        $("#continue-repair-back-btns").show();
        window.dispatchEvent(new Event("resize"));

        break;

      case "IHTVDA":
        $("#repair_summary").attr("appointment-type", "");

        selectedservice = "IHTVDA";
        $("#continue-repair-back-btns").show();
        window.dispatchEvent(new Event("resize"));

        break;  

      case "PSTVDA":
        $("#repair_summary").attr("appointment-type", "");

        selectedservice = "PSTVDA";
        $("#continue-repair-back-btns").show();
        window.dispatchEvent(new Event("resize"));

        break; 

      case "KISS":
        // console.log("tvInDays KISS ", window.state.tsoutcome.outcome);
        $("#repair_summary").attr("appointment-type", "KISS In-home repair");

        // Door replacement
        if (window.state.tsoutcome.outcome == "ihIIbooking") {
          // $('#kiss-ii-in-home-repair-steps').show();
          selectedservice = "KISSII";
        } else if (
          window.state.category == "homeappliance" &&
          window.state.product != "Vacuum Cleaners"
        ) {
          selectedservice = "KISSDA";
          const stepTexts = document.querySelectorAll("support-steps p");
          stepTexts.forEach(function (p) {
            switch (p.textContent) {
              case "Book your repair":
                p.textContent = "Request appointment";
                break;
              case "Confirm your booking":
                p.textContent = "Send request";
                break;
              case "Repair summary":
                p.textContent = "Request summary";
                break;
            }
          });
        
        } 
        // else if (window.state.category === "tvav") {
        //   selectedservice = "KISS";
        //   const stepTexts = document.querySelectorAll("support-steps p");

        //   stepTexts.forEach(function (p) {
        //     switch (p.textContent) {
        //       case "Book your repair":
        //         p.textContent = "Request appointment";
        //         break;
        //       case "Confirm your booking":
        //         p.textContent = "Send request";
        //         break;
        //       case "Repair summary":
        //         p.textContent = "Request summary";
        //         break;
        //     }
        //   });
        // } 
        else {
          // $('#kiss-in-home-repair-steps').show();

          selectedservice = "KISS";
        }

        window.dispatchEvent(new Event("resize"));
        $("#continue-repair-back-btns").show();

        break;

      case "BACKTOTS":
        $("#repair-solutions").html("");
        $("#repair-solutions").hide();
        $("#care-plus-repair").show();
        this.scrollTo("#care-plus-repair", 500);
        break;

        $("#repair_summary").attr("appointment-location", " ");
    }

    var repairStepsContent =
      site == "uk" ? RepairStepsContentUK : RepairStepsContentIE;
    // console.log("tvInDays", repairStepsContent, selectedservice);

    var source = this.templates
      ? this.templates.repairSteps
        ? this.templates.repairSteps
        : RepairSteps
      : RepairSteps;

    var template = Handlebars.compile(source);
    var compiled = template({
      title: repairStepsContent[selectedservice].title,
      steps: repairStepsContent[selectedservice].steps,
      disclaimer: repairStepsContent[selectedservice].disclaimer,
    });
    $("#general-repair-steps").html("");
    $("#general-repair-steps").html(compiled);
    this.scrollTo("#general-repair-steps", 500);

  }

  getDoorStepRepairUrl() {
    var tsRef = window.state.tsoutcome.lucidRef;
    var wtyEx = window.state.tsoutcome.warrantyException || window.state._wtyException;

    /** For AB testing experience B we are adding the string "-SKIP" after the lucid ref
            Because it won't work with the below url we have to remove the Skip from lucid ref if there is one **/

    tsRef = tsRef.replace("-SKIP", "");

    if (wtyEx == "VOID1") {
      return "https://samsungrepair.com/#/?lucidref=" + tsRef;
    } else {
      return (
        "https://samsungrepair.com/samsung-phone-warranty/?lucidref=" + tsRef
      );
    }
  }

  showConfirmPopup() {
    var popupText =
      "You will now be directed to our authorised repair partner website.";
    var popupCtaUrl = this.getDoorStepRepairUrl();

    this.confirmPopup = new ConfirmPopup(popupText, popupCtaUrl);

    this.confirmPopup.showConfirmPopup();
  }

  showSamsungMembersCTA() {
    var $this = this;

    var saLogin = {};
    saLogin = new SaLogin();

    /** Either login or not login user allowed to book KISS and Instore bookings **/
    if (window.state.selectedservice == "ISR") {
      $this.scrollToRepairBookingSection("#instore-repair-map");
      //$this.scrollTo('#repair-booking-form', 500);
      $this.showInstoreRepairMap();
    } else if (window.state.selectedservice == "KISS" || site == "ie") {
      $this.scrollToRepairBookingSection("#repair-request-form");
      //$this.scrollTo('#repair-booking-form', 500);
      $this.showBookingRepairForm();
    }

    //** Title Inside Login should be shown both the scenarios Login and not logged in **/

    // PS, IH, PSIH check added to the below code to get the Samsung account details for the KISS and Instore repair when the user logged in

    if (window.location.host != "supportrepair.samsung.com" && site != "ie") {
      saLogin.isUserLoggedIn().done(function (data) {
        /** only Login state user allowed to book Pickup repair other wise Samsung account banner shown to User **/

        if (window.state.isUserLoggedIn) {
          $("#sa-login").hide();

          if (
            window.state.selectedservice == "PS" ||
            window.state.selectedservice == "IH" ||
            window.state.selectedservice == "PSIH" ||
            window.state.selectedservice == "PSTV" ||
            window.state.selectedservice == "IHTVDA" ||
            window.state.selectedservice == "PSTVDA"
          ) {
            $this.scrollToRepairBookingSection("#repair-request-form");
            //$this.scrollTo('#repair-booking-form', 500);
            $this.showBookingRepairForm();
          }

          saLogin.getAccountDetails();
        } else {
          if (
            window.state.selectedservice == "PS" ||
            window.state.selectedservice == "IH" ||
            window.state.selectedservice == "PSIH" ||
            window.state.selectedservice == "PSTV" ||
            window.state.selectedservice == "IHTVDA" ||
            window.state.selectedservice == "PSTVDA"
          ) {
            $("#sa-login").show();
            $this.scrollTo("#sa-login", 10);
            saLogin.events();
          }
        }
      });
    } else {
      $("#top-banner .logout").show();
      $("#top-banner .login").hide();

      if (
        window.state.selectedservice == "PS" ||
        window.state.selectedservice == "IH" ||
        window.state.selectedservice == "PSIH" ||
        window.state.selectedservice == "PSTV" ||
        window.state.selectedservice == "IHTVDA" ||
        window.state.selectedservice == "PSTVDA"
      ) {
        $this.scrollToRepairBookingSection("#repair-request-form");
        $this.showBookingRepairForm();
      }
    }
  }

  showBookingRepairForm() {
    var $this = this;
    var homeRepair = {};
    homeRepair = new HomeRepair();
    $("#repair-request-form").show();
    $("#repair-request-form .container.form").show();

    if ($(".s-layer-dimmed").length > 0) {
      $(".s-layer-dimmed").hide();
      $(".s-layer-dimmed").remove();
      $(".lds-ring1").hide();
    }
  }

  showInstoreRepairMap() {
    var $this = this;
    $("#instore-repair-map").show();
    // loading Google Maps
    googleMaps();

    /* Google Maps API event */
    window.MapLoaded = () => {
      const storeLocator = new StoreLocatorv1();
    };

    /** Always show the Map first even the state changed from Map to pick the slots previous user interactions **/
    $(".sl-selector-start").show(1);
    $(".sl-appointment-start").hide(1);

    // this.initZoomAppointmentPopup();
    //this.scrollTo('#stepstorepair', 500);
    $(window).trigger("resize");

    //battary replacement
    if (window.state._tsoutcome.selectedIssue == "Battery Replacement") {
      $("#store-locator .sl-wrapper-title h3").html("Please enter your postcode to find your nearest location");
    } else {
      $("#store-locator .sl-wrapper-title h3").html("Please enter your postcode to find your nearest In-store Repair location");
    }
  }

  /*    initZoomAppointmentPopup() {

        $('#store-locator .banner-container .s-btn-cta').off('click').on('click', function(event){

            event.preventDefault();
            $(window).scrollTop(0);
            $('.zoom-popup').show();
            $('.s-layer-dimmed').css('opacity', 0.5);
            $('.s-layer-dimmed').show();

        });

    }
*/

  drawDaysConfirmation() {
    var $this = this;

    var source = $this.templates.daysConfirmation;
    var template = Handlebars.compile(source);
    var compiled = template({});

    // $("#repair-request-form").html("");
    // $("#repair-request-form").html(compiled);
    // $("#repair-request-form").show();
    $("#repair-solutions").html("");
    $("#repair-solutions").html(compiled);

    $("#repair-solutions").show();
    $this.scrollTo("#repair-solutions", 500);

    $this.events();
  }

  drawRepairServiceSection(asList) {
    //console.log('Draw repair service section');

    var $this = this;

    var RSCopy = $this.repairServiceCopy();

    // If this is a battery replacement journey, update the copy
    if (window.state.isBatteryReplacement) {
      // Update In-store repair description for battery replacement
      if (RSCopy.isrepair) {
        // Store the original description
        if (!RSCopy.isrepair.originalDescription) {
          RSCopy.isrepair.originalDescription = RSCopy.isrepair.description;
        }

        RSCopy.isrepair.title = "In-store Service";

        // Update with battery replacement specific description
        RSCopy.isrepair.description = "Book an appointment with a Samsung Expert at one of our Authorised Service Centres.<br/><br/>Book the date, time and location that works best for you.<br/><br/>Our Authorised Service Partner will confirm cost and timings for the replacement at your appointment.<br/><br/><br/>";
      }
    } else {
      // Restore original description if it was modified before
      if (RSCopy.isrepair && RSCopy.isrepair.originalDescription) {
        RSCopy.isrepair.description = RSCopy.isrepair.originalDescription;
      }
    }

    /** For Doorstep fold3 and flip3 got different description of service **/
    if (this.flip3fold3) {
      RSCopy.dsrepair.desc = RSCopy.dsrepair.descriptionfold3flip3;
    } else {
      RSCopy.dsrepair.desc = RSCopy.dsrepair.description;
    }

    var trIn = "";
    var trUp = "";
    var trUpTV = "";

    var ps = $.inArray("PS", asList) != -1 ? "PS" : "";
    var pstv = $.inArray("PSTV", asList) != -1 ? "PSTV" : "";
    var dsr = $.inArray("DSR", asList) != -1 ? "DSR" : "";
    var isr = $.inArray("ISR", asList) != -1 ? "ISR" : "";
    var ih = $.inArray("IH", asList) != -1 ? "IH" : "";

    var ihtvda = $.inArray("IHTVDA", asList) != -1 ? "IHTVDA" : "";
    var pstvda = $.inArray("PSTVDA", asList) != -1 ? "PSTVDA" : "";

    // if ( window.state._category == 'mobile'  && site != 'ie') {
    //     trIn =( $.inArray( "TRIN", asList) != -1 )? 'trIn':'';
    // }

    if (site === "ie" && window.state._category === "mobile") {
        // Define constants upfront
        const SERVICE_CENTER_URL = "https://www.samsung.com/ie/support/service-centre/";
        const SELECTOR = "#ie-instore-repair .btn-container.inline";
        const MAX_ATTEMPTS = 100;
        const CHECK_INTERVAL = 100; // milliseconds

        isr = "ISR";

        // Update description text
        if (RSCopyIE && RSCopyIE.isrepair) {
          RSCopyIE.isrepair.description = `Find your closest Authorised Serivce Centre to get face-to-face product support. <br><br> Our Authorised Service Centre will confirm cost and timings for the repair at your appointment. <br><br> To organise your appointment, our Authorised Service Centre details can be found on our Service Locator Page.`;
        }

        // Function to handle the button replacement logic
        const replaceButton = (parentElement) => {
          const continueBtnCta = parentElement.find(".s-btn-cta.repair-soluton-btn");

          // Create new button with all attributes
          const newButton = $(
            `<a
              class="s-btn-cta repair-soluton-btn"
              href="javascript:void(0);"
              data-service-type="ISR"
              target="_blank"
              data-omni-type="microsite"
              data-omni="repair:mobile:${RSCopy.title}_${RSCopy.isrepair.title}_${RSCopy.isrepair.btncopy}"
              ga-ac="feature"
              ga-ca="repair"
              ga-la="mobile:${RSCopy.title}_${RSCopy.isrepair.title}_${RSCopy.isrepair.btncopy}"
            >${RSCopy.isrepair.btncopy}</a>`
          );

          // Add click handler directly to the new button before replacing
          newButton.on("click", function(e) {
            e.preventDefault()
            window.open(SERVICE_CENTER_URL, "_blank");
          });

          // Replace the old button with the new one
          continueBtnCta.replaceWith(newButton);
        };

        // Try to find the element immediately first
        const parentElement = $(SELECTOR);
        if (parentElement.length) {
          // Element already exists, replace button immediately
          replaceButton(parentElement);
        } else {
          // Element doesn't exist yet, set up interval with timeout protection
          let attempts = 0;
          const checkElementInterval = setInterval(() => {
            attempts++;
            const parentElement = $(SELECTOR);

            if (parentElement.length) {
              // Element found, replace button and clear interval
              clearInterval(checkElementInterval);
              replaceButton(parentElement);
            } else if (attempts >= MAX_ATTEMPTS) {
              // Safety timeout - stop checking after maximum attempts
              clearInterval(checkElementInterval);
              console.log(`Element ${SELECTOR} not found after ${MAX_ATTEMPTS} attempts`);
            }
          }, CHECK_INTERVAL);
        }
      }

    var noTradinProducts = [
      "Galaxy  Buds  F E",
      "Galaxy Buds F E",
      // "Galaxy S24",
      "Galaxy S25",
      "Galaxy Smart Tag",

      "Galaxy A14 4G",
      "Galaxy A14 5G",
      "Galaxy A34 5G",
      "Galaxy A54 5G",
      "Galaxy A23 5G",
      "Galaxy A35 5G",
      "Galaxy A55 5G",
      "Galaxy A05s",
      "Galaxy A15 5G",
      "Galaxy A15 LTE",
      "Galaxy A25 5G",
      "Galaxy A16 5G",
      "Galaxy A16 LTE",
      "Galaxy A26 5G",
      "Galaxy A36 5G",
      "Galaxy A56 5G",

      "Galaxy Tab A9+ 5G Wi-Fi",
      "Galaxy Tab A9+ Wi-Fi",
      "Galaxy Tab A9 4G Wi-Fi",
      "Galaxy Tab A9 Wi-Fi",

      "Galaxy Tab S10+ 5G Wi-Fi",
      "Galaxy Tab S10+ Wi-Fi",
      "Galaxy Tab S10 Ultra Wi-Fi",
      "Galaxy Tab S10 Ultra 5G Wi-Fi",

      "Galaxy Tab S6 Wi-Fi",
      "Galaxy Tab S10 FE+ 5G",
      "Galaxy Tab S10 FE+ Wi-Fi",
      "Galaxy Tab S10 FE 5G",
      "Galaxy Tab S10 FE Wi-Fi",


      "Galaxy Tab Active5",
      "Galaxy XCover7",
      "Galaxy Watch FE",
      "Galaxy Z Flip6",
      "Galaxy Z Fold6",
      "Galaxy Ring",

      "Galaxy Fit3",

      "Galaxy Watch7",
      "Galaxy Watch Ultra",
      "Galaxy Buds3",
      "Galaxy Buds3 Pro",
      "HW-B430 2.1Ch Soundbar",
      "HW-B450 2.1ch Soundbar",
      "HW-Q600B 3.1.2ch Soundbar",
      "HW-Q60B 3.1ch Soundbar",
      "HW-Q990B",


    ];

    var productNameForDisplay = window.state._tsoutcome && window.state._tsoutcome.tsProductNameForDisplay
        ? window.state._tsoutcome.tsProductNameForDisplay
        : window.state._product || "Galaxy Device";

    // console.log(window.state._tsoutcome.tsProductNameForDisplay)

    productNameForDisplay = productNameForDisplay
      .toLowerCase()
      .replace(/ /g, "")
      .replace("+", "plus")
      .replace("wi-fi", "wifi");

    // console.log(productNameForDisplay);

    var isTradein = false;

    if (window.state._category == "mobile" && site != "ie") {
      isTradein = true;

      $.each(noTradinProducts, function (key, prodName) {
        //productNameForDisplay = productNameForDisplay.toLowerCase().trim().replace(/\s/g, '');

        prodName = prodName
          .toLowerCase()
          .replace(/ /g, "")
          .replace("+", "plus")
          .replace("wi-fi", "wifi");

        // remove spaces of both and check the code, un comment the above code

        if (productNameForDisplay.includes(prodName)) {
          isTradein = false;
          return false;
        }
      });
    }

    // console.log("Is trade in " + isTradein);

    trIn = isTradein ? "trIn" : "";

    if (
      window.state._product == "Refrigerator" &&
      window.state._tsoutcome.selectedIssue == "Damage to the appliance" &&
      site != "ie"
    ) {
      trUp = "trUp";
    }

    if (
      window.state._product == "Laundry" &&
      window.state._tsoutcome.selectedIssue == "I have damaged my machine" &&
      site != "ie"
    ) {
      trUp = "trUp";
    }

    if (
      window.state._product == "Vacuum Cleaners" &&
      window.state._tsoutcome.selectedIssue == "Broken appliance issues" &&
      site != "ie"
    ) {
      trUp = "trUp";
    }

    if (
      window.state._product == "TV" &&
      window.state._tsoutcome.selectedIssue == "Ive damaged my device" &&
      site != "ie"
    ) {
      trUpTV = "trUpTV";
    }

    // If the category of products not covered in Product mapping and it has PS & IH service
    var psih = "";
    var title = RSCopy.title;
    if (window.state.ispmnotavailable && ps != "" && ih != "") {
      psih = "PSIH";
      ps = "";
      ih = "";
      title = RSCopy.psihrepair.sectiontitle;
    }

    if (
      window.state._productName === "The Premiere LSP7T Single Laser"  && window.state._product === "Projector" || 
      window.state._productName === "The Premiere LSP9T Triple Laser"  && window.state._product === "Projector" 
    ) {
      pstvda = ""
      ihtvda = "ihtvda"
    }

    //$('#lockers-banner').show();

    var source = $this.templates.repairSolution;
    var template = Handlebars.compile(source);
    var compiled = template({
      rsCopy: RSCopy,
      PS: ps,
      PSTV: pstv,
      DSR: dsr,
      ISR: isr,
      IH: ih,
      PSIH: psih,
      TRIN: trIn,
      TRUP: trUp,
      TRUPTV: trUpTV,
      IHTVDA: ihtvda,
      PSTVDA: pstvda,
      title: title,
      site: site,
      type: window.state._product,
      category: window.state._product.replace(/\s/g, ""),
    });

    // console.log(
    //   "productServices",
    //   trIn,
    //   trUp,
    //   trUpTV,
    //   isr,
    //   ps,
    //   pstv,
    //   dsr,
    //   ih,
    //   psih
    // );
    let productServices = [trIn, trUp, trUpTV, isr, ps, pstv, dsr, ih, psih, ihtvda, pstvda];

    let listLength = productServices.filter(
      (v) => v !== undefined && v !== ""
    ).length;
    listLength = listLength > 4 ? 4 : listLength;
    $("#repair-solutions").html("");
    $("#repair-solutions").addClass("rows-grid-" + listLength);
    $("#repair-solutions").html(compiled);

    $("#repair-solutions").show();
    $this.scrollTo("#repair-solutions", 500);

    $this.carouselInit();
    $this.events();
  }

  carouselInit() {
    $(".repair-solutions-mob .rows__container").slick({
      centerMode: true,
      infinite: false,
      slidesToShow: 1,
      dots: true,
      arrows: false,
    });
  }

  drawUBPriceSection(UBPRPriceForSelectedProduct) {
    /*        var UBPRPrice = this.ubPickupRepairPrice();
        const troubleShootedProduct = window.state.tsoutcome.troubleshootedProduct.split('/')[1].toLowerCase();

        var UBPRPriceForSelectedProduct = "";

        console.log(UBPRPrice);

        $.each(UBPRPrice, function(key,element) {

            var model = element.model.toLowerCase();
            model = model.replace(/ /g, '');
            model = model.replace('+', 'plus');

            if (troubleShootedProduct.includes(model)) {
                UBPRPriceForSelectedProduct = element;
            }


        });*/

    //console.log(UBPRPriceForSelectedProduct);

    //$('#lockers-banner').show();

    if (
      $("#repair-solutions").hasClass("rows-grid-4") ||
      $("#repair-solutions").hasClass("rows-grid-3") ||
      $("#repair-solutions").hasClass("rows-grid-2") ||
      $("#repair-solutions").hasClass("rows-grid-1")
    ) {
      $("#repair-solutions")
        .removeClass("rows-grid-4")
        .removeClass("rows-grid-3")
        .removeClass("rows-grid-2")
        .removeClass("rows-grid-1");
    }

    $("#repair-solutions").addClass("rows-grid-2");

    // console.log("Inside draw UB price");

    var source = this.templates.ubPrice;
    var template = Handlebars.compile(source);
    var compiled = template({
      ubPrice: UBPRPriceForSelectedProduct,
    });

    $("#repair-solutions").html(compiled);

    $("#repair-solutions").show();

    this.events();
  }

  redirectToContact() {
    window.location.href = "/" + site + "/support/contact/";

    //this.scrollTo('#contactus', 100);
    //$('#contactus').length
  }

  scrollTo(elem, delay) {
    if ($(elem).length) {
      var stepsSummaryHeight = $(".steps-wrapper").outerHeight() + 20;
      stepsSummaryHeight += $(".floating-navigation").hasClass(
        "floating-navigation--fixed"
      )
        ? 0
        : $(".steps-wrapper").outerHeight();

      stepsSummaryHeight += $(".summary-wrapper").is(":visible")
        ? $(".summary-wrapper").outerHeight()
        : 0;

      var scrollTop = $(elem).position().top - stepsSummaryHeight;

      //var scrollTop = $(elem).position().top;
      setTimeout(function () {
        $("html, body").animate(
          {
            scrollTop: scrollTop,
          },
          500,
          function () {}
        );
      }, delay);
    }
  }

  repairServiceCopy() {
    return site === "uk" ? RSCopyUK : RSCopyIE;
  }

  ubPickupRepairPrice() {
    var $this = this;

    return UBPrice.ubprice.sort((a, b) => b.model.length - a.model.length);

    //console.log('ubPickupRepairprice', $this.ubModels.length);
    /*
        if ( $this.ubModels.length != 0) {

            //Sort the array by model name length decending
            return $this.ubModels.sort((a, b) => b.model.length - a.model.length);

        } else {
            //Sort the array by model name length decending
            return UBPrice.ubprice.sort((a, b) => b.model.length - a.model.length);

        }*/
  }
}
